// components/Navbar.jsx
import React, { useEffect, useState } from "react";
import "./Navbar.css";

const Navbar = ({ items }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const bodyHeight = document.body.offsetHeight;
      const atBottom = scrollY + windowHeight >= bodyHeight - 150;
      if (scrollY > 10 && !atBottom) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, anchor) => {
    e.preventDefault();
    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <nav className={`navbar${visible ? " navbar-visible" : " navbar-hidden"}`}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <a 
            className="navbar-item" 
            href={`#${item.anchor}`}
            onClick={(e) => handleNavClick(e, item.anchor)}
          >
            {item.label}
          </a>
          {index < items.length - 1 && <span className="navbar-separator" />}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Navbar;